import React from 'react';

const error = (props) => {
    if (!props.errorMsg || props.errorMsg === '') {
        return null;
    }
    return (
        <div className="alert alert-danger alert-white rounded mT5">
            <div className="icon"><i className="fa fa-info-circle"></i></div>
            <span>{props.errorMsg}</span>
        </div>
    )
};

export default error;